export default __webpack_public_path__ + "static/media/audio.13237abe.svg";